import { Skeleton } from "@/components/ui/skeleton";

export function ProjectDetailSkeleton() {
  return (
    <div className="flex flex-col gap-8 mt-10">
      {/* 제목 */}
      <Skeleton className="h-7 w-2/3 rounded-xl" />

      {/* 메타정보 영역 */}
      <div className="flex gap-4">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-20" />
      </div>

      {/* 썸네일 */}
      <Skeleton className="w-full h-[420px] rounded-xl" />

      {/* 본문 타이틀 */}
      <Skeleton className="h-6 w-1/3 mt-8 rounded-xl" />

      {/* 본문 내용 */}
      <div className="space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/6" />
      </div>

      {/* 기술스택 / 섹션 구분 */}
      <div className="mt-12 space-y-2">
        <Skeleton className="h-5 w-1/4 rounded-xl" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-6 w-20 rounded-lg" />
          ))}
        </div>
      </div>
    </div>
  );
}
